/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Collaborators_Nocollaboratorsfoundtitle3Inputs */

const en_settings_collaborators_nocollaboratorsfoundtitle3 = /** @type {(inputs: Settings_Collaborators_Nocollaboratorsfoundtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No collaborators found`)
};

/**
* | output |
* | --- |
* | "No collaborators found" |
*
* @param {Settings_Collaborators_Nocollaboratorsfoundtitle3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_collaborators_nocollaboratorsfoundtitle3 = /** @type {((inputs?: Settings_Collaborators_Nocollaboratorsfoundtitle3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Collaborators_Nocollaboratorsfoundtitle3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_collaborators_nocollaboratorsfoundtitle3(inputs)
});
export { settings_collaborators_nocollaboratorsfoundtitle3 as "settings_collaborators_noCollaboratorsFoundTitle" }